import { ReactNode, createContext, useContext } from "react";
import { useFilterProviderType } from "./filter-provider-type.hook";

const FilterProviderTypeContext = createContext(
  {} as ReturnType<typeof useFilterProviderType>
);
export function useFilterProviderTypeContext() {
  return useContext(FilterProviderTypeContext);
}

interface FilterProviderTypeProviderProps {
  children: ReactNode;
}
export function FilterProviderTypeProvider({
  children,
}: FilterProviderTypeProviderProps) {
  return (
    <FilterProviderTypeContext.Provider value={useFilterProviderType()}>
      {children}
    </FilterProviderTypeContext.Provider>
  );
}